
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.667 23.368c.56-.53 1.296-1.032 2.204-1.486C9.173 20.73 12.4 20 16 20c3.6 0 6.827.73 9.13 1.882.907.454 1.642.956 2.203 1.486l-.933.365 3.066 1.6.4-2.8-1.2.295c-.748-.832-1.767-1.552-2.94-2.139-2.524-1.262-5.964-2.023-9.727-2.023-3.762 0-7.202.761-9.726 2.023-1.173.587-2.192 1.307-2.94 2.139l-1.2-.295.4 2.8 3.066-1.6-.933-.365z","fill":"currentColor"}})])
          )
        }
      }
    